export default {"src":"/_next/static/media/save-money.mono.022627bd.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};